/* istanbul ignore next */
const onError = () => {};

/* istanbul ignore next */
const onSuccess = () => {};

const defaultParams = {
    async: true,
    defer: true,
    onSuccess,
    onError,
};

class ScriptLoader {
    /* istanbul ignore next */
    static loadSnippet(snippet, params) {
        /* istanbul ignore next */
        if (!__SERVER__) {
            const props = Object.assign(true, {}, defaultParams, params);
            // Commenting snippet as per WANLY-8596
            // const scriptSnippet = document.createElement('script');
            // scriptSnippet.innerHTML = snippet;
            // scriptSnippet.type = 'text/javascript';
            // document.head.appendChild(scriptSnippet);

            const scriptEl = document.createElement('script');
            scriptEl.src = props.src;
            scriptEl.async = props.async;
            scriptEl.crossorigin = props.crossorigin;

            scriptEl.onload = props.onSuccess;
            scriptEl.onerror = props.onError;
            document.head.appendChild(scriptEl);
        } else {
            throw new Error('notSupportedException');
        }
    }

    static load(params) {
        if (!__SERVER__) {
            const props = Object.assign(true, {}, defaultParams, params);
            const scriptEl = document.createElement('script');

            scriptEl.src = props.src;
            scriptEl.async = props.async;
            scriptEl.defer = props.defer;
            scriptEl.crossorigin = props.crossorigin;

            scriptEl.onload = props.onSuccess;
            scriptEl.onerror = props.onError;

            document.body.appendChild(scriptEl);
        } else {
            throw new Error('notSupportedException');
        }
    }

    static loadAccertify(params) {
        if (!__SERVER__) {
            const props = Object.assign(true, {}, defaultParams, params);
            const scriptEl = document.createElement('script');
            scriptEl.setAttribute('type', 'text/javascript');
            if (!props.src) {
                throw new Error('Accertify src url missing');
            }
            Object.keys(props).forEach((key) => {
                if (!['onError', 'onSuccess'].includes(key)) {
                    scriptEl.setAttribute(key, props[key]);
                }
            });
            scriptEl.async = true;
            scriptEl.onload = props.onSuccess;
            scriptEl.onerror = props.onError;
            document.head.appendChild(scriptEl);
        } else {
            throw new Error('notSupportedException');
        }
    }

    static loadSYFQuickScreen(params) {
        if (!__SERVER__) {
            const props = Object.assign(true, {}, defaultParams, params);
            const scriptEl = document.createElement('script');
            scriptEl.setAttribute('type', 'text/javascript');
            if (!props.src) {
                throw new Error('syf quickscreen src url missing');
            }
            Object.keys(props).forEach((key) => {
                if (!['onError', 'onSuccess'].includes(key)) {
                    scriptEl.setAttribute(key, props[key]);
                }
            });
            scriptEl.async = false;
            scriptEl.defer = true;
            scriptEl.onload = props.onSuccess;
            scriptEl.onerror = props.onError;
            document.head.appendChild(scriptEl);
        } else {
            throw new Error('notSupportedException');
        }
    }

    static loadBuyNowPayLater(params) {
        if (!__SERVER__) {
            const props = Object.assign(true, {}, defaultParams, params);
            const scriptEl = document.createElement('script');
            scriptEl.setAttribute('type', 'text/javascript');
            if (!props.src) {
                throw new Error('syf bnpl src url missing');
            }
            Object.keys(props).forEach((key) => {
                if (!['onError', 'onSuccess'].includes(key)) {
                    scriptEl.setAttribute(key, props[key]);
                }
            });
            scriptEl.async = false;
            scriptEl.defer = true;
            scriptEl.onload = props.onSuccess;
            scriptEl.onerror = props.onError;
            document.head.appendChild(scriptEl);
        } else {
            throw new Error('notSupportedException');
        }
    }
}

export default ScriptLoader;
